import { Modal, Button, Form, Card, Row, Col } from "@themesberg/react-bootstrap";
import { useEffect, useState } from "react";
import ToastPopup from "src/app/common/ToastPopup";

const AddEditUserModal = ({
	editUserData,
	showAddEditUserModal,
	handleAddEditCloseButtonClick,
	getAllUsersDataFromContext,
	createUserFromContext,
	updateUserDataFromContext,
	setAddEditButtonClicked,
}) => {
	const [userData, setUserData] = useState({
		name: "",
		email: "",
		phone: "",
		password: "",
		password_confirmation: "",
		roles: [],
	});

	const handleInputChange = (e) => {
		if (!e?.target) return;

		console.log(e.target.value);

		if (e?.target?.name === "roles") {
			if (e?.target?.value > 0) {
				setUserData({
					...userData,
					[e?.target?.name]: [e?.target?.value],
				});
			} else {
				setUserData({
					...userData,
					[e?.target?.name]: [],
				});
			}
		} else {
			setUserData({
				...userData,
				[e?.target?.name]: e?.target?.value,
			});
		}
	};

	const handleUpdateOrSubmitButton = () => {
		if (
			userData?.name !== "" &&
			userData?.email.match(
				/(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})/g
			)?.[0] &&
			userData?.phone !== "" &&
			(editUserData || userData?.password?.length >= 8) &&
			userData?.roles?.length > 0
		) {
			if (editUserData) {
				updateUserDataFromContext(userData?.id, userData, () =>
					getAllUsersDataFromContext()
				);
			} else {
				let newUserData = { ...userData, password_confirmation: userData?.password };
				createUserFromContext(newUserData, () => getAllUsersDataFromContext());
			}
			handleAddEditCloseButtonClick();
		} else {
			console.log("not passed!!");
			if (userData?.name === "") {
				ToastPopup("error", "Username must not be empty!!");
				return;
			}

			if (
				!userData?.email.match(
					/(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})/g
				)?.[0]
			) {
				ToastPopup("error", "Email is not valid!!");
				return;
			}

			if (userData?.phone === "") {
				ToastPopup("error", "Phone number must not be empty");
				return;
			}

			if (userData?.password?.length < 8) {
				ToastPopup("error", "Password length must be at least 8!!");
				return;
			}

			if (userData?.roles?.length <= 0) {
				ToastPopup("error", "Please select user role!!");
				return;
			}
		}
	};

	useEffect(() => {
		if (editUserData) {
			console.log("set user data in side effect");
			setUserData({
				id: editUserData?.id,
				name: editUserData?.name,
				email: editUserData?.email,
				phone: editUserData?.phone,
				roles: [editUserData?.roles?.[0]?.id],
			});
		}
	}, [editUserData]);

	console.log(editUserData, userData);

	return (
		<Modal
			centered
			size="lg"
			className="modal-tertiary"
			show={showAddEditUserModal}
			onHide={() => {}}
		>
			<Modal.Header>
				<Button
					variant="close"
					className="btn-close-dark text-dark"
					aria-label="Close"
					onClick={() => {
						setAddEditButtonClicked(false);
						handleAddEditCloseButtonClick();
					}}
				/>
			</Modal.Header>
			<Modal.Body className=" py-3">
				<div className="px-5">
					<center>
						<h5 className="mb-4">{editUserData ? "Edit User" : "Add User"}</h5>
					</center>
					<Row>
						<Col md={6} className="mb-3">
							<Form.Group id="userName">
								<Form.Label>Name</Form.Label>
								<Form.Control
									required
									type="text"
									name="name"
									value={userData?.["name"] ?? ""}
									onChange={(e) => handleInputChange(e)}
									placeholder="Enter Name"
								/>
							</Form.Group>
						</Col>
						<Col sm={6} className="mb-3">
							<Form.Group id="userEmail">
								<Form.Label>Email</Form.Label>
								<Form.Control
									required
									type="text"
									name="email"
									value={userData?.["email"] ?? ""}
									onChange={(e) => handleInputChange(e)}
									placeholder="Enter Email"
								/>
							</Form.Group>
						</Col>
					</Row>

					<Row>
						<Col sm={6} className="mb-3">
							<Form.Group id="userPhone">
								<Form.Label>Phone</Form.Label>
								<Form.Control
									required
									type="number"
									name="phone"
									value={userData?.["phone"] ?? ""}
									onChange={(e) => handleInputChange(e)}
									placeholder="Enter Phone"
								/>
							</Form.Group>
						</Col>
						{!editUserData && (
							<Col md={6} className="mb-3">
								<Form.Group id="password">
									<Form.Label>Password</Form.Label>
									<Form.Control
										required
										type="password"
										name="password"
										value={userData?.["password"] ?? ""}
										onChange={(e) => handleInputChange(e)}
										placeholder="******"
									/>
								</Form.Group>
							</Col>
						)}
					</Row>

					<Row>
						<Col sm={6} className="mb-3">
							<Form.Group id="userPhone">
								<Form.Label>Roles</Form.Label>
								<Form.Select
									required
									name="roles"
									value={userData?.["roles"]?.[0] ?? 0}
									onChange={(e) => handleInputChange(e)}
								>
									<option value={0}>Select Role</option>
									<option value={1}>Admin</option>
									<option value={2}>Property Owner</option>
								</Form.Select>
							</Form.Group>
						</Col>
					</Row>
				</div>
			</Modal.Body>
			<Modal.Footer className="z-2 text-end">
				<Row>
					<Col lg={12}>
						<div className="mx-4 text-end">
							<Button variant="dark" onClick={() => handleUpdateOrSubmitButton()}>
								{editUserData ? "Update" : "Submit"}
							</Button>
						</div>
					</Col>
				</Row>
			</Modal.Footer>
		</Modal>
	);
};

export default AddEditUserModal;
